import { defineAsyncComponent } from 'vue'

// Archive template components
export const archiveBlockDefinitions = {
  content_download: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-archive/ArchiveDownloadBlock.vue')
    ),
    fields: ['*.*']
  },
  content_image: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-archive/ArchiveImageBlock.vue')
    ),
    fields: ['*.*']
  },
  content_images: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-archive/ArchiveImagesBlock.vue')
    ),
    fields: ['*', 'images.content_image_id.*.*']
  },
  content_info_block: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/UpdateBlock.vue')
    ),
    fields: ['*']
  },
  content_social: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/SocialBlock.vue')
    ),
    fields: ['*']
  },
  content_teasers: {
    component: defineAsyncComponent(() =>
      import('~/components/blocks-archive/ArchiveTeasersBlock.vue')
    ),
    fields: ['*', 'articles.*', 'articles.*.*']
  }
}
